<template>
    <li class="DropdownOption">
        <button
            :class="[
                'DropdownOption__button',
                selected && 'DropdownOption__button--selected'
            ]"
            @click="optionClick"
        >
            <span class="DropdownOption__label">
                <RPCheckbox
                    v-if="showCheckbox"
                    :value="selected"
                    class="DropdownOption__checkbox"
                />
                {{ label }}
            </span>
            <span class="DropdownOption__description">
                <StreamlineIcon
                    v-if="showIcon"
                    class="DropdownOption__icon"
                    :icon="icon"
                    :size="16"
                    :stroke="iconColor"
                />
                {{ description }}
            </span>
        </button>
    </li>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import RPCheckbox from '../RPCheckbox.vue';
import isEmpty from 'lodash/isEmpty';
import {primary, textDark} from 'style/_colors.scss';
import statusBuilder from 'status/statusBuilder';
import status from 'status';

export default {
    name: 'DropdownOption',
    components: {
        RPCheckbox,
        StreamlineIcon
    },
    props: {
        value: {
            type: [String, Number, Boolean],
            default: null
        },
        label: {
            type: String,
            required: true,
        },
        icon: {
            type: [Object, Array],
            default: () => ({}),
        },
        color: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: '',
        },
        showCheckbox: {
            type: Boolean,
            default: false
        },
        selected: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        option(){
            return{
                value: this.value,
                label: this.label,
                icon: this.icon,
                color: this.color,
                description: this.description,
                disabled: this.disabled,
            };
        },
        showIcon(){
            return !isEmpty(this.icon);
        },
        iconColor(){
            if(this.color !== ''){
                return this.color;
            }
            return this.selected
                ? primary
                : textDark;
        },
    },
    methods: {
        selectedClass(base){
            return statusBuilder(
                base,
                status.STANDBY,
                false,
                {
                    selected: this.selected,
                    'no-border': this.noBorder
                }
            );
        },
        optionClick(){
            if(this.selected ){
                this.$emit('deselect', this.value);
            } else {
                this.$emit('select', this.value);
            }
        }
    }
};
</script>
<style lang="scss">
    .DropdownOption {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border-top: 1px solid $grey-100;
        background: $white;

        &__button{
            min-height: 2rem;
            width: 100%;
            padding: .25rem .5rem;
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            white-space: nowrap;
            overflow: hidden;
            align-items: center;
            gap: 1rem;
            &:hover{ background: $grey-50; }
            &:active{ background: $primary-50; }
            &--selected {
                color: $primary;
                background: $primary-50;
                &:hover{ background: $primary-50; }
            }
        }
        &__icon,
        &__checkbox{
            margin-right: 0.25rem;
        }
        &__label,
        &__description{
            display: flex;
            align-items: center;
            white-space: nowrap;
        }
        &__description {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
</style>
